import { render, staticRenderFns } from "./subjectResourceAnalysis.vue?vue&type=template&id=3d8e05c4&scoped=true"
import script from "./subjectResourceAnalysis.vue?vue&type=script&lang=js"
export * from "./subjectResourceAnalysis.vue?vue&type=script&lang=js"
import style0 from "./subjectResourceAnalysis.vue?vue&type=style&index=0&id=3d8e05c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8e05c4",
  null
  
)

export default component.exports